export const flattenMessages = (
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
  nestedMessages: any,
  flattenedFallbackMessages: Record<string, string> = {}
): Record<string, string> => {
  const flatten = (nestedMessages: any, prefix = ''): Record<string, string> =>
    Object.keys(nestedMessages).reduce((messages, key) => {
      const value = nestedMessages[key];
      const prefixedKey = prefix ? `${prefix}.${key}` : key;

      if (typeof value === 'string') {
        return {
          ...messages,
          [prefixedKey]: value
        };
      }

      return {
        ...messages,
        ...flatten(value, prefixedKey)
      };
    }, {});
  const flattenedMessages: Record<string, string> = flatten(nestedMessages);
  Object.keys(flattenedFallbackMessages).forEach((key) => {
    if (!flattenedMessages[key]) {
      flattenedMessages[key] = flattenedFallbackMessages[key];
    }
  });
  return flattenedMessages;
};
